module.exports = __webpack_public_path__ + "img/app-store.f354931d.png";